import { UserResponseDTO } from './user.model';

export interface AuthResponse {
  user: UserResponseDTO;
  token: string;
  refreshToken: string;
}

export interface AuthCredentials {
  username: string;
  password: string;
}

export interface LoginFormEntity {
  username: string;
  password: string;
}
